import React from "react";
import { ChatContainerWrap } from "./components";
import { useGetChat } from "./hooks";

const ChatInnerPage = () => <ChatContainerWrap useHook={useGetChat} />;
export default ChatInnerPage;
